import cloneDeep from 'lodash/cloneDeep';

import moment from 'moment';

class CustomerNote {
  constructor({
    id, customerID, title, note, flag, deleted, lastModified,
  }) {
    this.id = id;
    this.customerID = customerID;
    this.title = title || '';
    this.note = note || '';
    this.flag = flag || false;
    this.deleted = deleted || false;
    this.lastModified = lastModified && moment(lastModified);
  }

  clone() {
    return cloneDeep(this);
  }

  toApiFormat() {
    return {
      ID: this.id,
      CustomerID: this.customerID,
      Title: this.title,
      Note: this.note,
      Flag: this.flag,
      Deleted: this.deleted,
      LastModified: this.lastModified,
    };
  }

  static fromApiFormat(api) {
    return new CustomerNote({
      id: api.ID,
      customerID: api.CustomerID,
      title: api.Title,
      note: api.Note,
      flag: api.Flag,
      deleted: api.Deleted,
      lastModified: api.LastModified,
    });
  }
}

export default CustomerNote;
